import React from 'react';
import { Link } from 'react-router-dom';
import HexMark from './HexMark';
import layout from '../styles/layout.module.css';
import styles from './ContactSection.module.css';

/** 既定の段落（トップ・一覧ページ）。記事ページは description で差し替える */
const DEFAULT_DESCRIPTION =
  'サービスに関するご質問、パートナーシップのご相談など。月次顧問契約・スポット支援に対応しています。';

interface ContactSectionProps {
  description?: string;
}

const ContactSection: React.FC<ContactSectionProps> = ({
  description = DEFAULT_DESCRIPTION,
}) => {
  return (
    <section
      id="contact"
      className={styles.contact}
      role="region"
      aria-labelledby="contact-title"
    >
      <div className={`${layout.wrap} ${styles.grid}`}>
        <div className={styles.copy}>
          <p className={styles.eyebrow}>
            <HexMark size={14} color="paper" />
            CONTACT
          </p>
          <h2 id="contact-title" className={styles.title}>
            まずは、お気軽にご相談ください。
          </h2>
          <p className={styles.text}>{description}</p>
        </div>
        <Link to="/contact" className={styles.button}>
          お問い合わせフォームへ
        </Link>
      </div>
    </section>
  );
};

export default ContactSection;
